import React, { createContext, useContext, useState, useEffect, useCallback, useMemo } from 'react';

const translations = {
  ar: {
    // Navbar
    nav: {
      home: 'الرئيسية',
      courses: 'الكورسات',
      paths: 'مسارات التعلم',
      library: 'المكتبة',
      simulations: 'المحاكاة',
      articles: 'المقالات',
      subscription: 'مميزات الاشتراك',
      about: 'من نحن',
      contact: 'تواصل معنا',
      login: 'تسجيل الدخول',
      subscribe: 'اشتراك',
    },
    // Hero
    hero: {
      badge: 'من الصفر إلى الاحتراف',
      title1: 'تعلم الأتمتة الصناعية',
      title2: 'والبرمجة',
      title3: 'من البداية للإحتراف',
      desc: 'كورسات عملية احترافية في البرمجة الصناعية وأنظمة التحكم PLC و SCADA بمنهج بسيط، أمثلة تطبيقية، ومشاريع حقيقية تؤهلك لسوق العمل.',
      cta1: 'استكشف الكورسات',
      cta2: 'مميزات الاشتراك',
    },
    features: {
      f1Title: 'دورات عملية احترافية', f1Desc: 'شرح عملي من البداية حتى الاحتراف',
      f2Title: 'مشاريع حقيقية', f2Desc: 'تطبيق عملي على مشاريع واقعية من سوق العمل',
      f3Title: 'كورسات قابلة للتحميل', f3Desc: 'ملخصات ومراجع شاملة لكل دورة',
      f4Title: 'شهادة إنجاز', f4Desc: 'احصل على شهادة معتمدة عند إكمال كل دورة',
      f5Title: 'دعم فني ومجتمع خاص', f5Desc: 'مساعدة مباشرة ومجتمع للطلاب والمشتركين',
    },
    sections: {
      latestCourses: 'أحدث الكورسات',
      latestCoursesDesc: 'اختر من مجموعة متنوعة من الكورسات المصممة بعناية',
      viewAll: 'عرض جميع الكورسات',
      pathsTitle: 'مسارات تعلم مقترحة',
      pathsDesc: 'تعلم بشكل منظم من خلال مسارات مصممة للوصول بك إلى الاحتراف',
      coursesCount: 'كورسات',
      testimonialsTitle: 'ماذا يقول طلابنا',
      testimonialsDesc: 'تجارب حقيقية من مجتمع Automeet Network',
      partnersTitle: 'موثوق من قبل شركات ومؤسسات',
      newsletterTitle: 'اشترك في نشرتنا البريدية',
      newsletterDesc: 'احصل على أحدث الكورسات والعروض والنصائح التقنية مباشرة على بريدك',
      newsletterPlaceholder: 'أدخل بريدك الإلكتروني',
      newsletterBtn: 'اشترك الآن',
      hours: 'ساعات',
      hour: 'ساعة',
    },
    stats: { students: 'طالب ومشترك', courses: 'كورس احترافي', hours: 'ساعة من المحتوى', projects: 'مشروع عملي' },
    footer: {
      brand: 'Automeet Network',
      desc: 'منصة عربية متخصصة في تعليم الأتمتة والبرمجة وأنظمة التحكم بطريقة عملية ومبسطة.',
      quickLinks: 'روابط سريعة',
      help: 'الدعم والمساعدة',
      contact: 'تواصل معنا',
      faq: 'الأسئلة الشائعة',
      privacy: 'سياسة الخصوصية',
      terms: 'الشروط والأحكام',
      refund: 'سياسة الاسترجاع',
      support: 'دعم فني',
      copyright: 'جميع الحقوق محفوظة © 2025 Automeet Network',
      address: 'الدعم متاح عبر البريد الإلكتروني',
      hours: 'نرد على رسائلك خلال 24 ساعة',
      email: 'info@automation-basita.com',
      phone: 'منصة تعليمية عبر الإنترنت',
    },
    auth: {
      loginTitle: 'تسجيل الدخول',
      loginSubtitle: 'سجل دخولك للوصول إلى حسابك',
      registerTitle: 'اشتراك جديد',
      registerSubtitle: 'انضم إلى مجتمع Automeet Network',
      email: 'البريد الإلكتروني',
      password: 'كلمة المرور',
      name: 'الاسم الكامل',
      confirmPassword: 'تأكيد كلمة المرور',
      forgot: 'نسيت كلمة المرور؟',
      loginBtn: 'دخول',
      registerBtn: 'اشتراك',
      orContinue: 'أو تابع باستخدام',
      googleLogin: 'الدخول بحساب جوجل',
      noAccount: 'ليس لديك حساب؟',
      haveAccount: 'لديك حساب بالفعل؟',
      adminBadge: 'دخول الأدمن',
    },
    library: {
      title: 'المكتبة',
      desc: 'مقالات ومنشورات تقنية متخصصة في الأتمتة الصناعية',
      readMore: 'اقرأ المزيد',
    },
    about: {
      title: 'من نحن',
      desc: 'منصة Automeet Network هي منصة تعليمية عربية متخصصة في الأتمتة الصناعية والبرمجة وأنظمة التحكم.',
      mission: 'رسالتنا',
      missionText: 'نسعى لتقديم محتوى تقني عالي الجودة باللغة العربية لتمكين المهندسين والفنيين من اكتساب مهارات احترافية في مجال الأتمتة.',
      vision: 'رؤيتنا',
      visionText: 'أن نكون المنصة العربية الأولى في تعليم الأتمتة الصناعية وأنظمة التحكم.',
    },
    contact: {
      title: 'تواصل معنا',
      desc: 'نحن هنا للإجابة على استفساراتك',
      name: 'الاسم',
      email: 'البريد الإلكتروني',
      subject: 'الموضوع',
      message: 'رسالتك',
      send: 'إرسال الرسالة',
      sent: 'تم إرسال الرسالة بنجاح',
    },
  },
  en: {
    nav: {
      home: 'Home',
      courses: 'Courses',
      paths: 'Learning Paths',
      library: 'Library',
      simulations: 'Simulations',
      articles: 'Articles',
      subscription: 'Subscription',
      about: 'About Us',
      contact: 'Contact',
      login: 'Login',
      subscribe: 'Subscribe',
    },
    hero: {
      badge: 'From Zero to Pro',
      title1: 'Learn Industrial Automation',
      title2: 'and Programming',
      title3: 'from Beginner to Pro',
      desc: 'Professional practical courses in industrial programming, PLC and SCADA control systems with a simple curriculum, applied examples, and real projects that prepare you for the job market.',
      cta1: 'Explore Courses',
      cta2: 'Subscription Benefits',
    },
    features: {
      f1Title: 'Professional Practical Courses', f1Desc: 'Practical explanation from beginner to pro',
      f2Title: 'Real Projects', f2Desc: 'Hands-on application on real-world projects',
      f3Title: 'Downloadable Courses', f3Desc: 'Comprehensive summaries and references for each course',
      f4Title: 'Completion Certificate', f4Desc: 'Get a certified certificate upon completion',
      f5Title: 'Tech Support & Community', f5Desc: 'Direct help and community for students',
    },
    sections: {
      latestCourses: 'Latest Courses',
      latestCoursesDesc: 'Choose from a variety of carefully designed courses',
      viewAll: 'View All Courses',
      pathsTitle: 'Suggested Learning Paths',
      pathsDesc: 'Learn in an organized way through paths designed to take you to professionalism',
      coursesCount: 'courses',
      testimonialsTitle: 'What Our Students Say',
      testimonialsDesc: 'Real experiences from the Automeet Network community',
      partnersTitle: 'Trusted by Companies and Institutions',
      newsletterTitle: 'Subscribe to our Newsletter',
      newsletterDesc: 'Get the latest courses, offers, and tech tips directly to your inbox',
      newsletterPlaceholder: 'Enter your email',
      newsletterBtn: 'Subscribe Now',
      hours: 'hours',
      hour: 'hour',
    },
    stats: { students: 'Students & Subscribers', courses: 'Professional Courses', hours: 'Hours of Content', projects: 'Practical Projects' },
    footer: {
      brand: 'Automeet Network',
      desc: 'An Arabic platform specialized in teaching automation, programming, and control systems in a practical and simple way.',
      quickLinks: 'Quick Links',
      help: 'Help & Support',
      contact: 'Contact Us',
      faq: 'FAQ',
      privacy: 'Privacy Policy',
      terms: 'Terms & Conditions',
      refund: 'Refund Policy',
      support: 'Tech Support',
      copyright: 'All Rights Reserved © 2025 Automeet Network',
      address: 'Support available by email',
      hours: 'We reply within 24 hours',
      email: 'info@automation-basita.com',
      phone: 'Online learning platform',
    },
    auth: {
      loginTitle: 'Login',
      loginSubtitle: 'Sign in to access your account',
      registerTitle: 'New Subscription',
      registerSubtitle: 'Join the Automeet Network community',
      email: 'Email',
      password: 'Password',
      name: 'Full Name',
      confirmPassword: 'Confirm Password',
      forgot: 'Forgot password?',
      loginBtn: 'Login',
      registerBtn: 'Subscribe',
      orContinue: 'Or continue with',
      googleLogin: 'Sign in with Google',
      noAccount: "Don't have an account?",
      haveAccount: 'Already have an account?',
      adminBadge: 'Admin Login',
    },
    library: {
      title: 'Library',
      desc: 'Technical articles and posts specialized in industrial automation',
      readMore: 'Read more',
    },
    about: {
      title: 'About Us',
      desc: 'Automeet Network is an Arabic educational platform specialized in industrial automation, programming, and control systems.',
      mission: 'Our Mission',
      missionText: 'We strive to provide high-quality technical content in Arabic to empower engineers and technicians with professional automation skills.',
      vision: 'Our Vision',
      visionText: 'To be the leading Arabic platform in teaching industrial automation and control systems.',
    },
    contact: {
      title: 'Contact Us',
      desc: 'We are here to answer your inquiries',
      name: 'Name',
      email: 'Email',
      subject: 'Subject',
      message: 'Your Message',
      send: 'Send Message',
      sent: 'Message sent successfully',
    },
  }
};

const LanguageContext = createContext();

const readCachedOverrides = () => {
  try { return JSON.parse(localStorage.getItem('siteTexts') || '{}'); } catch (e) { return {}; }
};

let siteOverrides = readCachedOverrides();

export const tx = (lang, ar, en) => {
  const o = siteOverrides[`L:${ar}`];
  return lang === 'ar' ? (o?.ar || ar) : (o?.en || en);
};

const applyDictOverrides = (dict, lang, overrides) => {
  const out = JSON.parse(JSON.stringify(dict));
  Object.entries(overrides).forEach(([key, val]) => {
    if (!key.startsWith('t:')) return;
    const path = key.slice(2).split('.');
    let node = out;
    for (let i = 0; i < path.length - 1; i += 1) {
      if (typeof node[path[i]] !== 'object') return;
      node = node[path[i]];
    }
    const leaf = path[path.length - 1];
    if (typeof node[leaf] === 'string' && val?.[lang]) node[leaf] = val[lang];
  });
  return out;
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    return localStorage.getItem('lang') || 'ar';
  });
  const [overrides, setOverrides] = useState(siteOverrides);

  const reloadSiteTexts = useCallback(async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/site-texts`);
      const data = res.ok ? await res.json() : {};
      siteOverrides = data;
      localStorage.setItem('siteTexts', JSON.stringify(data));
      setOverrides(data);
    } catch (e) {
      setOverrides(siteOverrides);
    }
  }, []);

  useEffect(() => { reloadSiteTexts(); }, [reloadSiteTexts]);

  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
    localStorage.setItem('lang', lang);
  }, [lang]);

  const toggleLang = () => setLang(prev => (prev === 'ar' ? 'en' : 'ar'));
  const t = useMemo(() => applyDictOverrides(translations[lang], lang, overrides), [lang, overrides]);
  const isRTL = lang === 'ar';

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggleLang, t, isRTL, overrides, reloadSiteTexts }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLang must be used within LanguageProvider');
  return ctx;
};

export const pickLocalized = (val, lang) => {
  if (val == null) return '';
  if (typeof val === 'string') return val;
  return val[lang] || val.ar || val.en || '';
};
